/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import IntegrationRoutes from './integration.routes';
import AddIntegrationController from './add-integration.controller';
import IntegrationDirective from './integration.directive';
import IntegrationTableConfig from './integration-table.config';

export default angular.module('tektelic.integration', [])
    .config(IntegrationRoutes)
    .controller('AddIntegrationController', AddIntegrationController)
    .directive('tkIntegration', IntegrationDirective)
    .factory('integrationTableConfig', IntegrationTableConfig)
    .name;



// WEBPACK FOOTER //
// ./src/app/integration/index.js